import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { useTheme } from '@/components/Theme';

import config from './config';

export const TailwindSandboxTwyne = ({ children, styles = '' }) => {
  const ref = useRef(null);
  const [document, setDocument] = useState(null)
  const adminTheme = useTheme()

  useEffect(() => {
    if (document) {
      const handleKeyEvent = event => {
        const clonedEvent = new KeyboardEvent(event.type, event)
        window.dispatchEvent(clonedEvent)
      }

      document.addEventListener('keydown', handleKeyEvent)
      document.addEventListener('keyup', handleKeyEvent)

      return () => {
        document.removeEventListener('keydown', handleKeyEvent)
        document.removeEventListener('keyup', handleKeyEvent)
      }
    }
  }, [document])

  return <>
    <iframe
      ref={ref}
      onLoad={() => setDocument(ref.current.contentDocument)}
      className='w-full h-full overflow-hidden'
      srcDoc={`
        <!DOCTYPE html>
        <html class=''>
          <head>
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
            <script src="https://cdn.jsdelivr.net/npm/@tailwindcss/browser@4"></script>
            ${styles}
          </head>
          <body class="${adminTheme} scrollbar"></body>
        </html>
      `}
    />
    {document && createPortal(children, document.body)}
    {document && createPortal(<style type='text/tailwindcss' dangerouslySetInnerHTML={{
      __html: [
        `@import "tailwindcss";
         @custom-variant dark (&:where(.dark, .dark *));
         ${config}`,
        `:root .scrollbar {\n  --scrollbar-track-bg: transparent;\n  --scrollbar-thumb-bg: theme('colors.gray.300');\n  --placeholder-color: theme('colors.gray.300')\n}\n\n:root .scrollbar.dark {\n  --scrollbar-track-bg: transparent;\n  --scrollbar-thumb-bg: theme('colors.gray.800');\n  --placeholder-color: theme('colors.gray.800');\n}\n\n.scrollbar ::-webkit-scrollbar {\n  width: .25rem;\n  height: .25rem\n}\n\n.scrollbar ::-webkit-scrollbar-track {\n  background-color: var(--scrollbar-track-bg);\n  border-radius: 100vw;\n  margin-block: 0\n}\n\n.scrollbar ::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-thumb-bg);\n  border: 1px solid var(--scrollbar-track-bg);\n  border-radius: 100vw\n}`,
      ].join('\n'),
    }} />, document.head)}
  </>
}
